module.exports = __webpack_public_path__ + "static/media/gw.5ecbd93c.svg";